import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Asset } from '@app/core/model/entities/asset/asset';
import { EquipmentInput } from '@app/core/model/entities/equipments/equipment';
import {
  EquipmentCreateModalComponent
} from '@app/features/main/views/equipments/equipments-inventory/modals/equipment-create-modal/equipment-create-modal.component';

@Component({
  templateUrl: './asset-equipment-create-modal.component.html',
  standalone: false
})
export class AssetEquipmentCreateModalComponent extends EquipmentCreateModalComponent implements OnInit {
  protected asset = inject<{ asset: Asset }>(MAT_DIALOG_DATA).asset;
  public formId = 'asset_equipment_creation_dialog';

  /**
   * Data from the filled form.
   * @return Equipment data.
   */
  public getGeneratedObject(): EquipmentInput {
    return {
      ...this.equipmentInput,
      assetId: this.asset.id
    };
  }
}
